import { createContext, use, useCallback, useState } from 'react'

type NewInquiryContext = {
  title: string
  showInquiryDialog: boolean
  onChangeTitle: (title: string) => void
  resetTitle: () => void
  openInquiryDialog: () => void
  closeInquiryDialog: () => void
}
const newInquiryContext = createContext<NewInquiryContext | undefined>(
  undefined,
)

const DEFAULT_TITLE = '試験に関する問い合わせ'

export const useNewInquiry = (): NewInquiryContext => {
  const [title, setTitle] = useState(DEFAULT_TITLE)

  const [showInquiryDialog, setShowInquiryDialog] = useState(false)

  const onChangeTitle = useCallback((title: string) => {
    setTitle(title)
  }, [])

  const resetTitle = useCallback(() => {
    setTitle(DEFAULT_TITLE)
  }, [])

  const openInquiryDialog = useCallback(() => {
    setShowInquiryDialog(true)
  }, [])

  const closeInquiryDialog = useCallback(() => {
    setShowInquiryDialog(false)
    setTitle(DEFAULT_TITLE)
  }, [])

  return {
    title,
    showInquiryDialog,
    onChangeTitle,
    resetTitle,
    openInquiryDialog,
    closeInquiryDialog,
  }
}

export const NewInquiryContextProvider = newInquiryContext.Provider

export const useNewInquiryContext = (): NewInquiryContext => {
  const context = use(newInquiryContext)
  if (!context) {
    throw new Error(
      'useNewInquiryContext must be used within a NewInquiryContextProvider',
    )
  }
  return context
}
